import { lowerCase, upperFirst } from 'lodash-es';

import { browserLanguage } from './languageSettings';

export const formatNumber = (value: number, maximumFractionDigits: number = 2, minimumFractionDigits: number = 0) =>
  new Intl.NumberFormat(browserLanguage(), {
    maximumFractionDigits,
    minimumFractionDigits
  }).format(value);

export const formatCurrency = (
  currency: string,
  value: number,
  currencyDisplay: 'code' | 'symbol' | 'name' = 'code',
  fractionDigitsConfig: FractionDigitsConfig = defaultFractionDigitsConfig,
  locale = browserLanguage()
) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay,
    ...fractionDigitsConfig
  }).format(value);
};

export const FORMAT_DATE_TRANSFERABLE = 'YYYY-MM-DD'; // eg. 14th April 2020, 11:36am
export const FORMAT_DATE_TIME_TRANSFERABLE = 'YYYY-MM-DDTHH:mm:ss.sssZ'; // ISO 8601 Extended Format

export const defaultFractionDigitsConfig: FractionDigitsConfig = {};
export const noFractionDigitsConfig: FractionDigitsConfig = { maximumFractionDigits: 0, minimumFractionDigits: 0 };

export type ContactName = { firstName: string; lastName: string };

export interface FractionDigitsConfig {
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
}

export const getFullName = ({ firstName, lastName }: ContactName) => `${firstName} ${lastName}`;

export const truncateText = (text: string, maxLength: number) => {
  if (maxLength > text.length) {
    return text;
  }

  const slicedText = text.slice(0, maxLength);

  return `${slicedText}...`;
};

export const removeSpecialCharactersAndUpperFirst = (text: string): string => {
  return upperFirst(lowerCase(text));
};
